/*
 * @Author: tanyaohua 
 * @Date: 2021-04-Th 11:40:05 
 * @Last Modified by:   mikey.zhaopeng 
 * @Last Modified time: 2021-04-Th 11:40:05 
 */
'use strict';
angular.module('util.trsFrame', []).directive('trsFrame', [
    '$sce',
    function ($sce) {
        return {
            restrict: 'E',
            scope: {
                url: '@', // iframe地址
            },
            reaplace: false,
            templateUrl: './components/util/trsFrame/trsFrame.html',
            link: function ($scope) {
                $scope.url = $sce.trustAsResourceUrl($scope.url);
            },
        };
    },
]);
